import DefaultParams from "@/utils/defalut_params.js";
import CachSendEmail from "@/utils/cach_send_email.js";
import { sendEmail } from "@/api/question/index.js";
import evevt_bus from "@/utils/evevt_bus.js";

const btnSubmit = document.querySelector("#contact-form .btn-submit");

if (btnSubmit) {
  btnSubmit.onclick = function (e) {
    e.preventDefault();
    const canSendEmail = CachSendEmail.sendEmailEnable();
    if (!canSendEmail) {
      // 一个小时内超过两次，禁止发送
      evevt_bus.$emit("show_toast", {
        value: "You operation are too frequent. Take a break!",
        error: true
      });
      return;
    }
    const user_name = document.querySelector("#contact-form-name").value;
    const user_email = document.querySelector(
      "#contact-form-email_contact-form-email"
    ).value;
    const user_message = document.querySelector("#contact-form-message").value;
    const nativeParams = { ...DefaultParams.getAppInfo() };
    const access_token = nativeParams.access_token;
    delete nativeParams["access_token"];
    const body = {
      ...nativeParams,
      feedback: {
        name: user_name,
        email: user_email,
        suggestion: user_message
      }
    };
    console.log("body", body);
    sendEmail(body, access_token)
      .then(() => {
        CachSendEmail.storageSendParams();
        evevt_bus.$emit("show_toast", {
          value: "Thanks for submitting."
        });
      })
      .catch(() => {
        evevt_bus.$emit("show_toast", {
          value: "Something went wrong.",
          error: true
        });
      });
  };
}

// var contactForm = $("#contact-form");
// if (contactForm.length) {
//   $(document).on("submit", "#contact-form", function (e) {
//     e.preventDefault();
//     var error_message = contactForm.find(".error-message");
//     var success_message = contactForm.find(".success-message");
//     var user_name = contactForm.find("input[name=name]").val();
//     var user_email = contactForm.find("input[name=email]").val();
//     var user_message = contactForm.find("textarea[name=message]").val();

//     //data to be sent to server

//     $.ajax({
//       url: "https://hup7d519i8.execute-api.us-east-1.amazonaws.com/dev/messages",
//       type: "POST",
//       headers: { "Content-Type": "application/json" },
//       data: JSON.stringify(post_data),
//       success: Swal.fire(
//         "Good job!",
//         "Your message has been sent successfully.",
//         "success"
//       )
//     });
//     return false;
//   });
// }
